import React, { useContext } from 'react'
import { SessionContextStore } from '../../../context/SessionContext'
import './AppBarProfile.scss'
import FlexView from 'react-flexview/lib'
import EmptyProfileImg from '../../../assets/sidemenu/noprofile_image.png'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { useMediaQuery } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { SessionService } from '../../../services/SessionService'
import BrokerConfigService from '../../../services/BrokerConfigService'
import { SkywatchThemeContext } from '../../../theme/Theme'
var classNames = require('classnames')

export const AppBarProfile = () => {
  const sessionContext = useContext(SessionContextStore)
  const themeContext = useContext(SkywatchThemeContext)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const history = useHistory()

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openAccount = () => {
    history.push('/account/profile')
    handleClose()
  }

  const openLogout = () => {
    history.push('/logout')
    handleClose()
  }

  let user = SessionService.isLoggedIn() && SessionService.isBroker() && sessionContext.broker ? sessionContext.broker : sessionContext.user

  return (
    <React.Fragment>
      <FlexView className="clickable" onClick={handleClick} vAlignContent={'center'}>
        <img
          src={user.profilePicture ? user.profilePicture : EmptyProfileImg}
          className={classNames(
            'appbar-profile-img',
            { 'profile-border-pri': !Boolean(themeContext.useColoredBackground) },
            { 'profile-border-sec': Boolean(themeContext.useColoredBackground) }
          )}
        />
        {!isMobileByWidth && (
          <div
            className={classNames(
              'text-body margin-left-6 capitalize',
              { white: Boolean(themeContext.useColoredBackground) },
              { blue: !Boolean(themeContext.useColoredBackground) }
            )}
          >
            {user.firstName} {user.lastName}
          </div>
        )}
      </FlexView>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {/* {!SessionService.isBroker() && <MenuItem onClick={openAccount}>My Account</MenuItem>} */}
        <MenuItem onClick={openLogout}>Logout</MenuItem>
      </Menu>
    </React.Fragment>
  )
}
